import { render, staticRenderFns } from "./MessagingMenu.vue?vue&type=template&id=4d87d018&scoped=true&"
import script from "./MessagingMenu.vue?vue&type=script&lang=js&"
export * from "./MessagingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87d018",
  null
  
)

export default component.exports